
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"34","viewBox":"0 0 36 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"chevron-left_svg__a","maskUnits":"userSpaceOnUse","x":"12","y":"7","width":"12","height":"20"}},[_c('path',{attrs:{"d":"M22.842 26.33l.928-.865a.498.498 0 000-.74L15.3 16.82l8.47-7.904a.498.498 0 000-.74l-.928-.864a.592.592 0 00-.795 0l-9.817 9.138a.498.498 0 000 .74l9.817 9.138c.22.205.575.205.795 0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#chevron-left_svg__a)"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 .065h36v33.512H0z"}})])])
          )
        }
      }
    